module.exports = __webpack_public_path__ + "img/4076d21.jpg";